<template>
  <media
    v-if="displayType === DISPLAY_TYPES.MEDIA"
    :is-component="true"
    :site-id="currentSite.id"
    :display-trailers="urlProperties.displayTrailers"
    :display-media="urlProperties.displayMedia"
    :media-class-id="urlProperties.mediaClassId"
    :display-title-class-id="urlProperties.titleClassId"
    :muted="urlProperties.muted"
    :display-footer="urlProperties.displayFooter"
    :display-message="urlProperties.displayMessages"
    :display-animated-posters="urlProperties.displayAnimatedPosters"
    :display-movie-banners="urlProperties.displayMovieBanners"
    :display-movie-posters="urlProperties.displayMoviePosters"
    :footer-background-color="urlProperties.footerBackgroundColor"
    :media-background-color="urlProperties.mediaBackgroundColor"
    :message-background-color="urlProperties.messageBackgroundColor"
    :default-display-duration="urlProperties.defaultDisplayDuration"
    :display-time="urlProperties.displayTime"
    :footer-text-color="urlProperties.footerTextColor"
  />
  <screen
    v-else-if="displayType === DISPLAY_TYPES.SCREEN"
    :override-screen-id="urlProperties.screenId"
    :override-show-screen-name="urlProperties.showScreenName"
    :override-margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :override-debug="urlProperties.debug"
    :override-cover="urlProperties.cover"
  />
  <screen-landscape
    v-else-if="displayType === DISPLAY_TYPES.SCREEN_LANDSCAPE"
    :screen-id="urlProperties.screenId"
    :show-screen-name="urlProperties.showScreenName"
    :margin-vertical="urlProperties.marginVertical"
    :margin-horizontal="urlProperties.marginHorizontal"
    :debug="urlProperties.debug"
    :show-logo="urlProperties.showLogo"
    :show-rating-reason="urlProperties.showRatingReason"
  />
  <screen-landscape-poster-left
    v-else-if="displayType === DISPLAY_TYPES.SCREEN_LANDSCAPE_POSTER_LEFT"
    :screen-id="urlProperties.screenId"
    :show-screen-name="urlProperties.showScreenName"
    :margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :debug="urlProperties.debug"
    :show-logo="urlProperties.showLogo"
    :show-rating-reason="urlProperties.showRatingReason"
  />
  <screen-portrait
    v-else-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT"
    :screen-id="urlProperties.screenId"
    :show-screen-name="urlProperties.showScreenName"
    :margin-vertical="urlProperties.marginVertical"
    :margin-horizontal="urlProperties.marginHorizontal"
    :debug="urlProperties.debug"
    :show-logo="urlProperties.showLogo"
    :show-rating-reason="urlProperties.showRatingReason"
    :detail="urlProperties.detail"
    :more-before="urlProperties.moreBefore"
    :more-after="urlProperties.moreAfter"
  />
  <screen-portrait-status-stream
    v-else-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM"
    :screen-id="urlProperties.screenId"
    :show-screen-name="urlProperties.showScreenName"
    :margin-vertical="urlProperties.marginVertical"
    :margin-horizontal="urlProperties.marginHorizontal"
    :debug="urlProperties.debug"
    :show-logo="urlProperties.showLogo"
    :show-rating-reason="urlProperties.showRatingReason"
    :detail="urlProperties.detail"
    :more-before="urlProperties.moreBefore"
    :more-after="urlProperties.moreAfter"
  />
  <site
    v-else-if="displayType === DISPLAY_TYPES.SITE"
    is-component
    :override-site-id="currentSite.id"
    :override-margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :override-debug="urlProperties.debug"
    :override-cover="urlProperties.cover"
  />
  <site-2
    v-else-if="displayType === DISPLAY_TYPES.SITE_2"
    is-component
    :site-id="currentSite.id"
    :margin-vertical="urlProperties.marginVertical"
    :margin-horizontal="urlProperties.marginHorizontal"
    :debug="urlProperties.debug"
    :cover="urlProperties.cover"
    :page-mode="urlProperties.mode === 'page'"
    :cycle-mode="urlProperties.mode === 'cycle'"
    :movies-per-page="urlProperties.moviesPerPage"
    :use-blank-slots="urlProperties.useBlankSlots"
    :fixed-page-number="urlProperties.fixedPageNumber"
    :interval="urlProperties.interval"
    :compact-showing-times="urlProperties.compactShowingTimes"
    :compact-showing-length="urlProperties.compactShowingLength"
    :compact-showing-interval="urlProperties.compactShowingInterval"
    :showtime-font-multiplier="urlProperties.showtimeFontMultiplier"
    :display-showing-badges="urlProperties.displayShowingBadges"
  />
  <showings-poster
    v-else-if="displayType === DISPLAY_TYPES.SHOWINGS_POSTER"
    :override-site-id="currentSite.id"
    :override-margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :override-debug="urlProperties.debug"
    :override-cover="urlProperties.cover"
    :clean-image="urlProperties.cleanImage"
    :page-mode="urlProperties.mode === 'page'"
    :cycle-mode="urlProperties.mode === 'cycle'"
    :movies-per-page="urlProperties.moviesPerPage"
    :interval="urlProperties.interval"
  />
  <site-portrait
    v-else-if="displayType === DISPLAY_TYPES.SITE_PORTRAIT"
    :override-site-id="currentSite.id"
    :override-margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :override-debug="urlProperties.debug"
    :override-cover="urlProperties.cover"
  />
  <showings-banner
    v-else-if="displayType === DISPLAY_TYPES.SHOWINGS_BANNER"
    is-component
    :override-site-id="currentSite.id"
    :override-margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :override-debug="urlProperties.debug"
    :override-cover="urlProperties.cover"
    :clean-image="urlProperties.cleanImage"
    :page-mode="urlProperties.mode === 'page'"
    :cycle-mode="urlProperties.mode === 'cycle'"
    :interval="urlProperties.interval"
    :show-all-available-showtimes="urlProperties.showAllAvailableShowtimes"
  />
  <showings-list
    v-else-if="displayType === DISPLAY_TYPES.SHOWINGS_LIST"
    :override-site-id="currentSite.id"
    :override-margin-vertical="urlProperties.marginVertical"
    :override-margin-horizontal="urlProperties.marginHorizontal"
    :override-debug="urlProperties.debug"
    :override-cover="urlProperties.cover"
    :interval="urlProperties.interval"
    :page-mode="urlProperties.mode === 'page'"
    :cycle-mode="urlProperties.mode === 'cycle'"
    :movies-per-page="urlProperties.moviesPerPage"
    :hide-past="urlProperties.hidePast"
    :showings-hide-poster="urlProperties.showingsHidePoster"
  />
  <iframe
    v-else
    style="height: 100%; width: 100%"
    :src="displayUrl"
  />
</template>

<script>
import { defaultUrlProperties, DISPLAY_TYPES, getDisplayType, urlToProperties } from 'src/models/signage/SignageUrlBuilder'
import Media from 'src/modules/signage/Media'
import Screen from 'src/modules/signage/Screen'
import ScreenLandscape from 'src/modules/signage/ScreenLandscape'
import ScreenLandscapePosterLeft from 'src/modules/signage/ScreenLandscapePosterLeft'
import ScreenPortrait from 'src/modules/signage/ScreenPortrait'
import ScreenPortraitStatusStream from 'src/modules/signage/ScreenPortraitStatusStream'
import ShowingsBanner from 'src/modules/signage/ShowingsBanner'
import ShowingsList from 'src/modules/signage/ShowingsList'
import ShowingsPoster from 'src/modules/signage/ShowingsPoster'
import Site from 'src/modules/signage/Site'
import Site2 from 'src/modules/signage/Site2'
import SitePortrait from 'src/modules/signage/SitePortrait'

export default {
  name: 'SignageComponent',
  components: {
    Media,
    Screen,
    ScreenLandscape,
    ScreenLandscapePosterLeft,
    ScreenPortrait,
    ScreenPortraitStatusStream,
    Site,
    Site2,
    SitePortrait,
    ShowingsBanner,
    ShowingsPoster,
    ShowingsList
  },
  props: {
    displayUrl: {
      type: String,
      required: true
    }
  },
  configuration: ['currentSite'],
  data () {
    return {
      displayType: getDisplayType(this.displayUrl),
      customUrl: '',
      urlProperties: defaultUrlProperties
    }
  },
  watch: {
    displayUrl: {
      immediate: true,
      handler () {
        _.each(urlToProperties(this.displayUrl), prop => { this.urlProperties[prop.key] = isNaN(parseInt(prop.value)) ? prop.value : parseInt(prop.value) })
      }
    }
  },
  created () {
    _.extend(this, { DISPLAY_TYPES })
  }
}

</script>
